import React from 'react';
import { motion } from 'framer-motion';
import { Shield, RefreshCw, Trophy } from 'lucide-react';
export function ProductReveal() {
  const portals = [{
    id: 1,
    name: 'Fricción',
    desc: 'Lo que te drena deja de ser lo más fácil de tu vida.',
    icon: Shield
  }, {
    id: 2,
    name: 'Reemplazo',
    desc: 'No quitas hábitos: los cambias por micro-rituales que regulan tu mente.',
    icon: RefreshCw
  }, {
    id: 3,
    name: 'Recompensa',
    desc: 'Tu mente recibe evidencia semanal: sueño, enfoque, calma.',
    icon: Trophy
  }];
  return <section className="py-14 px-4 bg-matrix-bg relative overflow-hidden" data-id="element-262">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-matrix-primary/5 blur-[120px] rounded-full pointer-events-none" data-id="element-263" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-265">
          <h2 className="text-3xl md:text-5xl font-black text-matrix-orange mb-4" data-id="element-266">
            Presentando: Mente Maestra
          </h2>
          <p className="text-xl md:text-2xl text-matrix-muted mb-6" data-id="element-267">
            Protocolo Anti-Matrix (30 días)
          </p>
          <p className="text-lg text-matrix-text/80 mb-4 max-w-2xl mx-auto" data-id="element-268">
            Un audiolibro de 1 hora, escrito en segunda persona, intenso y
            directo.
          </p>
          <p className="text-2xl font-bold text-matrix-primary text-glow" data-id="element-269">
            No para motivarte. Para devolverte.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-270">
          {portals.map((portal, index) => <motion.div key={portal.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-matrix-surface border border-matrix-dim p-8 rounded-lg relative group hover:border-matrix-primary/50 transition-colors duration-300" data-id="element-271">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-matrix-orange to-transparent opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-272" />

              <div className="flex items-center justify-between mb-6" data-id="element-273">
                <span className="text-4xl font-black text-matrix-orange/20 group-hover:text-matrix-orange/40 transition-colors" data-id="element-274">
                  0{portal.id}
                </span>
                <portal.icon className="w-8 h-8 text-matrix-primary" data-id="element-275" />
              </div>

              <h3 className="text-xl font-bold text-matrix-text mb-2" data-id="element-276">
                Portal {portal.id}:{' '}
                <span className="text-matrix-primary" data-id="element-277">{portal.name}</span>
              </h3>
              <p className="text-matrix-muted leading-relaxed" data-id="element-278">{portal.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}